"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CensusCollector = exports.ChosenLandingPoint = exports.CompletedReason = exports.className = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var classnames_1 = __importDefault(require("classnames"));
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var PersonalDetails_1 = require("./PersonalDetails");
var Navigation_1 = require("./Navigation/Navigation");
var CensusCollectorStore_1 = __importDefault(require("./CensusCollectorStore"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var SpheresBackground_1 = require("./SpheresBackground/SpheresBackground");
var CutScene_1 = require("./CutScene/CutScene");
var SpheresBackgroundManager_1 = require("./SpheresBackground/SpheresBackgroundManager");
var react_transition_group_1 = require("react-transition-group");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var event_tracker_types_1 = require("@qwilr/event-tracker-types");
var InviteTeam_1 = require("Onboarding/CensusCollector/InviteTeam");
var ChooseLandingPoint_1 = require("./ChooseLandingPoint/ChooseLandingPoint");
var MakeQwilrYourOwn_1 = require("Onboarding/CensusCollector/MakeQwilrYourOwn/MakeQwilrYourOwn");
var ReactCSSTransitionGroup = require("react-addons-css-transition-group");
var inversify_react_1 = require("inversify-react");
var CensusCollectorMetadataStore_1 = __importDefault(require("Onboarding/CensusCollector/CensusCollectorMetadataStore"));
var Types_1 = require("User/Types");
var OnboardingTelemetryService_1 = __importDefault(require("Onboarding/OnboardingTelemetryService"));
var OnboardingTypes_1 = require("Onboarding/OnboardingTypes");
exports.className = "census-collector";
var PageName;
(function (PageName) {
    PageName["PersonalDetails"] = "personal-details";
    PageName["InviteUsers"] = "invite-users";
    PageName["ChooseLandingPoint"] = "Choose-landing-point";
    PageName["MakeQwilrYourOwn"] = "make-qwilr-your-own";
})(PageName || (PageName = {}));
var AnimationName;
(function (AnimationName) {
    AnimationName["Uniform"] = "onboarding-page-uniform-transition";
})(AnimationName || (AnimationName = {}));
var pageNameToTelemetryStepName = function (pageName) {
    var _a;
    return ((_a = {},
        _a[PageName.PersonalDetails] = event_tracker_types_1.OnboardingStepName.PersonalDetails,
        _a[PageName.InviteUsers] = event_tracker_types_1.OnboardingStepName.InviteUsers,
        _a[PageName.ChooseLandingPoint] = event_tracker_types_1.OnboardingStepName.Explorer,
        _a[PageName.MakeQwilrYourOwn] = event_tracker_types_1.OnboardingStepName.MakeQwilrYourOwn,
        _a)[pageName]);
};
var CompletedReason;
(function (CompletedReason) {
    CompletedReason["Empty"] = "empty";
    CompletedReason["Skipped"] = "skipped";
    CompletedReason["Finished"] = "finished";
})(CompletedReason || (exports.CompletedReason = CompletedReason = {}));
var ChosenLandingPoint;
(function (ChosenLandingPoint) {
    ChosenLandingPoint["Editor"] = "editor";
    ChosenLandingPoint["TemplateGallery"] = "templateGallery";
    ChosenLandingPoint["Dashboard"] = "dashboard";
})(ChosenLandingPoint || (exports.ChosenLandingPoint = ChosenLandingPoint = {}));
var CensusCollector = (function (_super) {
    __extends(CensusCollector, _super);
    function CensusCollector(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.showingCutscene = false;
        _this._currentStep = 0;
        _this._nextStep = null;
        _this.showingCutscene = !(_this.props.disableCutscene || ((_a = window.sessionStorage) === null || _a === void 0 ? void 0 : _a.getItem("disableCutscene")));
        return _this;
    }
    CensusCollector.prototype.componentDidMount = function () {
        this.updateTelemetryWhenStepChange();
        if (this.pageOrder.length === 0) {
            this.props.resolve(CompletedReason.Empty);
            return;
        }
        this.censusCollectorStore.registerTriggerPulse(this.spheresBackgroundManager.triggerPulse);
        if (this.usingFeature(FeatureFlag_1.FeatureFlag.MakeQwilrYourOwn)) {
            this.fetchBrandDetails();
        }
    };
    CensusCollector.prototype.componentWillUnmount = function () {
        this.censusCollectorStore.unregisterTriggerPulse();
    };
    CensusCollector.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement("div", { className: "".concat(exports.className), onMouseMove: function (event) {
                _this.spheresBackgroundManager.handleContainerMouseMove(event);
            } },
            react_1.default.createElement(SpheresBackground_1.SpheresBackground, { inPersonalDetails: this.currentPageName === PageName.PersonalDetails && !this.showingCutscene, spheresBackgroundManager: this.spheresBackgroundManager }),
            react_1.default.createElement(react_transition_group_1.CSSTransition, { in: !this.showingCutscene, mountOnEnter: true, unmountOnExit: true, timeout: 1000, classNames: "".concat(exports.className, "__nav-wrapper") },
                react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(exports.className, "__nav-wrapper")) }, this.navComponent)),
            !this.showingCutscene && this.currentPageComponent,
            react_1.default.createElement(react_transition_group_1.Transition, { appear: true, in: this.showingCutscene, timeout: 1000, onEnter: utils_1.forceReflow, mountOnEnter: true, unmountOnExit: true }, function (status) { return (react_1.default.createElement(CutScene_1.CutScene, { onComplete: (0, mobx_1.action)(function () {
                    _this.showingCutscene = false;
                }), status: status, cutsceneLines: ["Get ready to create", "something great..."] })); })));
    };
    Object.defineProperty(CensusCollector.prototype, "navComponent", {
        get: function () {
            return (react_1.default.createElement(Navigation_1.OnboardingNavigation, { currentStep: this.displayedStepCount, totalSteps: this.pageOrder.length, goToAPreviousStep: this.goToAPreviousStep, buttonLabel: "", exit: function () { }, positioning: Navigation_1.OnboardingNavigationPositioning.Absolute }));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CensusCollector.prototype, "displayedStepCount", {
        get: function () {
            return this._nextStep || this._currentStep || 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CensusCollector.prototype, "currentStep", {
        get: function () {
            return this._currentStep;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CensusCollector.prototype, "currentPageName", {
        get: function () {
            return this.currentStep != null ? this.pageOrder[this.currentStep] : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CensusCollector.prototype, "nextPageName", {
        get: function () {
            return this._nextStep != null ? this.pageOrder[this._nextStep] : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CensusCollector.prototype, "hasNextStep", {
        get: function () {
            if (this._currentStep != null) {
                return this._currentStep < this.pageOrder.length - 1;
            }
            else {
                return true;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CensusCollector.prototype, "displayedPages", {
        get: function () {
            return [this.currentPageName, this.nextPageName];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CensusCollector.prototype, "pageOrder", {
        get: function () {
            var pageOrder = [];
            var _a = this.censusCollectorMetadataStore, isTemplateSignup = _a.isTemplateSignup, isPageBuilderAISignup = _a.isPageBuilderAISignup;
            if (!this.user.firstName ||
                !this.user.hasSetPassword ||
                (this.userListLength === 1 && (!this.account.name || !this.account.phoneNumber))) {
                pageOrder.push(PageName.PersonalDetails);
            }
            if (this.userListLength === 1) {
                pageOrder.push(PageName.InviteUsers);
            }
            if (this.userListLength === 1 && this.usingFeature(FeatureFlag_1.FeatureFlag.MakeQwilrYourOwn)) {
                pageOrder.push(PageName.MakeQwilrYourOwn);
            }
            if (!isTemplateSignup && !isPageBuilderAISignup && !this.isMobile()) {
                pageOrder.push(PageName.ChooseLandingPoint);
            }
            return pageOrder;
        },
        enumerable: false,
        configurable: true
    });
    CensusCollector.prototype.onCompleteStep = function () {
        if (this.hasNextStep) {
            this.incrementStep();
        }
        else {
            this.props.resolve(CompletedReason.Finished);
        }
    };
    CensusCollector.prototype.updateTelemetryWhenStepChange = function () {
        var telemetryStepName = pageNameToTelemetryStepName(this.currentPageName);
        if (telemetryStepName) {
            this.onboardingTelemetryService.stepReached(telemetryStepName);
        }
    };
    CensusCollector.prototype.incrementStep = function () {
        var _this = this;
        if (this._nextStep != null) {
        }
        else if (this.hasNextStep) {
            this._nextStep = this._currentStep + 1;
            this._currentStep = null;
            setTimeout(function () {
                (0, mobx_1.runInAction)(function () {
                    _this._currentStep = _this._nextStep;
                    _this._nextStep = null;
                    _this.updateTelemetryWhenStepChange();
                });
            }, kaleidoscope_1.AnimationDuration.Long);
        }
    };
    CensusCollector.prototype.goToAPreviousStep = function (step) {
        var _this = this;
        if (this._nextStep == null && this._currentStep != null && step < this._currentStep) {
            this._nextStep = step;
            this._currentStep = null;
            setTimeout(function () {
                (0, mobx_1.runInAction)(function () {
                    _this._currentStep = step;
                    _this._nextStep = null;
                    _this.updateTelemetryWhenStepChange();
                });
            }, kaleidoscope_1.AnimationDuration.Long);
        }
    };
    Object.defineProperty(CensusCollector.prototype, "childProps", {
        get: function () {
            return {
                onComplete: this.onCompleteStep,
                config: this.props.config,
            };
        },
        enumerable: false,
        configurable: true
    });
    CensusCollector.prototype.getPageClassNames = function (pageName) {
        return (0, mobx_1.computed)(function () {
            return (0, classnames_1.default)("".concat(exports.className, "__page"), "".concat(exports.className, "__page--").concat(pageName), "center");
        }).get();
    };
    Object.defineProperty(CensusCollector.prototype, "currentPageComponent", {
        get: function () {
            var _a;
            var _this = this;
            return (react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(exports.className, "__page-container"), (_a = {},
                    _a["".concat(exports.className, "__page-container--idle")] = this._nextStep == null,
                    _a)) },
                react_1.default.createElement(ReactCSSTransitionGroup, { transitionName: AnimationName.Uniform, transitionAppear: true, transitionAppearTimeout: 1700, transitionEnterTimeout: 1700, transitionLeaveTimeout: 900, className: "".concat(exports.className, "__transition-group") },
                    this.currentPageName === PageName.PersonalDetails && (react_1.default.createElement("div", { className: this.getPageClassNames(PageName.PersonalDetails), onClick: function (event) {
                            var _a, _b;
                            if (event.target instanceof HTMLElement && ((_b = (_a = event.target).closest) === null || _b === void 0 ? void 0 : _b.call(_a, ".dropdown__button"))) {
                                _this.spheresBackgroundManager.triggerPulse(2);
                            }
                        } },
                        react_1.default.createElement(PersonalDetails_1.PersonalDetails, __assign({}, this.childProps)))),
                    this.currentPageName === PageName.InviteUsers && (react_1.default.createElement("div", { className: this.getPageClassNames(PageName.InviteUsers) },
                        react_1.default.createElement(InviteTeam_1.InviteTeam, __assign({}, this.childProps)))),
                    this.currentPageName === PageName.MakeQwilrYourOwn && (react_1.default.createElement("div", { className: this.getPageClassNames(PageName.MakeQwilrYourOwn) },
                        react_1.default.createElement(MakeQwilrYourOwn_1.MakeQwilrYourOwn, __assign({}, this.childProps)))),
                    this.currentPageName === PageName.ChooseLandingPoint && (react_1.default.createElement("div", { className: this.getPageClassNames(PageName.ChooseLandingPoint) },
                        react_1.default.createElement(ChooseLandingPoint_1.ChooseLandingPoint, __assign({}, this.childProps)))))));
        },
        enumerable: false,
        configurable: true
    });
    CensusCollector.prototype.fetchBrandDetails = function () {
        return __awaiter(this, void 0, Promise, function () {
            var fetchData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.censusCollectorStore.shouldFetchBrandDetails() && this.userListLength === 1)) return [3, 2];
                        return [4, this.apiService.fetchBrandDetails()];
                    case 1:
                        fetchData = _a.sent();
                        this.censusCollectorStore.updateBrandDetails(fetchData, "", this.account.name);
                        _a.label = 2;
                    case 2: return [2];
                }
            });
        });
    };
    var _a, _b, _c, _d, _e, _f, _g, _h;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], CensusCollector.prototype, "_currentStep", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], CensusCollector.prototype, "_nextStep", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], CensusCollector.prototype, "showingCutscene", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("spheresBackgroundManager"),
        __metadata("design:type", typeof (_a = typeof SpheresBackgroundManager_1.SpheresBackgroundManager !== "undefined" && SpheresBackgroundManager_1.SpheresBackgroundManager) === "function" ? _a : Object)
    ], CensusCollector.prototype, "spheresBackgroundManager", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("censusCollectorStore"),
        __metadata("design:type", typeof (_b = typeof CensusCollectorStore_1.default !== "undefined" && CensusCollectorStore_1.default) === "function" ? _b : Object)
    ], CensusCollector.prototype, "censusCollectorStore", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("censusCollectorMetadataStore"),
        __metadata("design:type", typeof (_c = typeof CensusCollectorMetadataStore_1.default !== "undefined" && CensusCollectorMetadataStore_1.default) === "function" ? _c : Object)
    ], CensusCollector.prototype, "censusCollectorMetadataStore", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("usingFeature"),
        __metadata("design:type", Function)
    ], CensusCollector.prototype, "usingFeature", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("isMobile"),
        __metadata("design:type", Function)
    ], CensusCollector.prototype, "isMobile", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("user"),
        __metadata("design:type", typeof (_d = typeof Types_1.IUserInAccount !== "undefined" && Types_1.IUserInAccount) === "function" ? _d : Object)
    ], CensusCollector.prototype, "user", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("account"),
        __metadata("design:type", Object)
    ], CensusCollector.prototype, "account", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("userListLength"),
        __metadata("design:type", Number)
    ], CensusCollector.prototype, "userListLength", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("onboardingTelemetryService"),
        __metadata("design:type", typeof (_e = typeof OnboardingTelemetryService_1.default !== "undefined" && OnboardingTelemetryService_1.default) === "function" ? _e : Object)
    ], CensusCollector.prototype, "onboardingTelemetryService", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("apiService"),
        __metadata("design:type", typeof (_f = typeof OnboardingTypes_1.IApiService !== "undefined" && OnboardingTypes_1.IApiService) === "function" ? _f : Object)
    ], CensusCollector.prototype, "apiService", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_g = typeof react_1.default !== "undefined" && react_1.default.ReactNode) === "function" ? _g : Object),
        __metadata("design:paramtypes", [])
    ], CensusCollector.prototype, "navComponent", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], CensusCollector.prototype, "displayedStepCount", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], CensusCollector.prototype, "currentStep", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], CensusCollector.prototype, "currentPageName", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], CensusCollector.prototype, "nextPageName", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], CensusCollector.prototype, "hasNextStep", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], CensusCollector.prototype, "displayedPages", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], CensusCollector.prototype, "pageOrder", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], CensusCollector.prototype, "onCompleteStep", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], CensusCollector.prototype, "incrementStep", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], CensusCollector.prototype, "goToAPreviousStep", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], CensusCollector.prototype, "childProps", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_h = typeof JSX !== "undefined" && JSX.Element) === "function" ? _h : Object),
        __metadata("design:paramtypes", [])
    ], CensusCollector.prototype, "currentPageComponent", null);
    CensusCollector = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], CensusCollector);
    return CensusCollector;
}(react_1.default.Component));
exports.CensusCollector = CensusCollector;
